:host {
  display: block;
  width: 100%;
  height: 100%;
}

#chat-message-bar {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
  gap: 10px;
}

#chat-textarea {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

textarea {
  flex-grow: 1;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-family: Frutiger-Light, sans-serif;
  font-size: 16px;
  padding: 5px 30px;
  border: 1px solid var(--ux-input-border-color);
  resize: none;
  overflow: auto;
  max-height: 46px;

  &::placeholder {
    line-height: 36px;
  }
}

ux-button {
  flex-shrink: 0;
  align-self: center;
  --ux-icon-button-width: 46px;
  --ux-icon-button-height: 46px;
  --ux-button-icon-size-large: 20px;
}

ux-input::part(label) {
  display: none;
}

ux-input::part(hint) {
  display: none;
}